module.exports = __webpack_public_path__ + "static/mcc-logo-492ad88ff51bb45096be546b76bf1c4f.png";